import React, { useCallback } from "react";
import { Box, MainText, MainTitle } from "app/components/common";
import { StyleSheet, View, Platform, Dimensions } from "react-native";
import {
  heightPercentageToDP,
  widthPercentageToDP,
} from "react-native-responsive-screen";
import Animated, {
  Extrapolate,
  interpolateNode,
  interpolateColors,
} from "react-native-reanimated";
import Colors from "@microdoing/shared/constants/Colors";
import i18n from "@microdoing/shared/i18n";
import theme from "app/Theme/Theme";

const { width, height } = Dimensions.get("window");

const NoteTalking = require("../../../assets/images/note-talking.png");
const QualityCheck = require("../../../assets/images/quality-check.png");
const ShowSkill = require("../../../assets/images/show-skill.png");

const DOT_SIZE = 8;

const getElements = () => [
  {
    image: NoteTalking,
    description: i18n.t("intro-text-1"),
    // description:
    //   "Chaque semaine, recevez des défis personnalisés sur les compétences choisies",
    title: i18n.t("intro-title-1"),
  },
  {
    image: QualityCheck,
    description: i18n.t("intro-text-2"),
    title: i18n.t("intro-title-2"),
  },
  {
    image: ShowSkill,
    description: i18n.t("intro-text-3"),
    title: i18n.t("intro-title-3"),
  },
];

const styles = StyleSheet.create({
  main: {
    flex: 1,
    width: widthPercentageToDP("100%"),
  },
  element: {
    marginTop: 70,
    width: widthPercentageToDP("100%"),
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  image: {
    resizeMode: "contain",
    height: heightPercentageToDP("25%"),
    width: 200,
  },
  dots: {
    marginBottom: heightPercentageToDP("4%"),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
  dot: {
    marginRight: DOT_SIZE + 2,
    height: DOT_SIZE,
    width: DOT_SIZE,
    borderRadius: DOT_SIZE / 2,
    backgroundColor: "#E7E7EE",
  },
});

const IntroCarousel = ({}) => {
  const scrollX = React.useRef(new Animated.Value(0)).current;

  const elements = useCallback(getElements(), []);

  return (
    <>
      <Animated.ScrollView
        style={styles.main}
        horizontal={true}
        decelerationRate={Platform.OS === "ios" ? 0 : "normal"}
        scrollEventThrottle={16}
        pagingEnabled={true}
        contentContainerStyle={{
          alignItems: "center",
          justifyContent: "center",
        }}
        // decelerationRate
        bounces={true}
        snapToInterval={width}
        snapToAlignment="center"
        showsHorizontalScrollIndicator={false}
        onScroll={Animated.event([
          { nativeEvent: { contentOffset: { x: scrollX } } },
        ])}
      >
        {elements.map((el, index) => {
          const inputRange = [
            (index - 1) * width,
            width * index,
            (index + 1) * width,
          ];

          const scale = interpolateNode(scrollX, {
            inputRange,
            outputRange: [0.8, 1, 0.8],
            extrapolate: Extrapolate.CLAMP,
          });

          const opacity = interpolateNode(scrollX, {
            inputRange,
            outputRange: [0.7, 1, 0.7],
            extrapolate: Extrapolate.CLAMP,
          });

          return (
            <View style={styles.element} key={el.title}>
              <Animated.Image
                style={[styles.image, { transform: [{ scale }], opacity }]}
                source={el.image}
              />
              <Box width="90%">
                <MainTitle variant="l7-bold" textAlign="center" marginTop="xl">
                  {el.title}
                </MainTitle>
              </Box>
              <Box width="80%">
                <MainText
                  variant="l4-medium"
                  textAlign="center"
                  marginTop="sm"
                  color="neutral.600"
                >
                  {el.description}
                </MainText>
              </Box>
            </View>
          );
        })}
      </Animated.ScrollView>
      <View style={styles.dots}>
        {elements.map((dot, index) => {
          const inputRange = [
            (index - 1) * width,
            width * index,
            (index + 1) * width,
          ];

          const scale = interpolateNode(scrollX, {
            inputRange,
            outputRange: [1, 1, 1],
            extrapolate: Extrapolate.CLAMP,
          });
          const backgroundColor = interpolateColors(scrollX, {
            inputRange,
            outputColorRange: ["#E7E7EE", theme.colors["brand.500"], "#E7E7EE"],
            // extrapolate: Extrapolate.CLAMP,
          });

          const dotWidth = interpolateNode(scrollX, {
            inputRange,
            outputRange: [DOT_SIZE, DOT_SIZE * 1.8, DOT_SIZE],
            extrapolate: Extrapolate.CLAMP,
          });
          return (
            <Animated.View
              key={index}
              style={[
                styles.dot,
                {
                  transform: [{ scale }],
                  backgroundColor,
                  width: dotWidth,
                },
              ]}
            />
          );
        })}
      </View>
    </>
  );
};

export default IntroCarousel;
